import { render, staticRenderFns } from "./MenuBonus.vue?vue&type=template&id=68f9d4bc&scoped=true&"
import script from "./MenuBonus.vue?vue&type=script&lang=js&"
export * from "./MenuBonus.vue?vue&type=script&lang=js&"
import style0 from "./MenuBonus.vue?vue&type=style&index=0&id=68f9d4bc&lang=scss&scoped=true&"
import style1 from "./MenuBonus.vue?vue&type=style&index=1&id=68f9d4bc&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f9d4bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68f9d4bc')) {
      api.createRecord('68f9d4bc', component.options)
    } else {
      api.reload('68f9d4bc', component.options)
    }
    module.hot.accept("./MenuBonus.vue?vue&type=template&id=68f9d4bc&scoped=true&", function () {
      api.rerender('68f9d4bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/MenuBonus.vue"
export default component.exports